export interface Category {
  id: number;
  name: string;
  namePl: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 911,
    name: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
  },
  {
    id: 912,
    name: "Hoodies/Sweaters",
    namePl: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
  },
  {
    id: 913,
    name: "T-Shirts",
    namePl: "T-Shirty",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
  },
  {
    id: 914,
    name: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-hail-line",
  },
  {
    id: 915,
    name: "Pants/Shorts",
    namePl: "Spodnie/Szorty",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
  },
  {
    id: 916,
    name: "Headwear",
    namePl: "Nakrycia głowy",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-smile-line",
  },
  {
    id: 917,
    name: "Sets",
    namePl: "Zestawy",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
  },
  {
    id: 918,
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-line",
  },
  {
    id: 919,
    name: "Jersey",
    namePl: "Koszulki sportowe",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-shirt-line",
  },
  {
    id: 920,
    name: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-vip-line",
  },
  {
    id: 921,
    name: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
  },
  {
    id: 922,
    name: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
  },
  {
    id: 923,
    name: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
  },
  {
    id: 924,
    name: "Other Stuff",
    namePl: "Inne produkty",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
  },
];